/**
 * Open the native / browser file picker from a user gesture.
 * macOS WKWebView (ATW Hub desktop app) often ignores <label htmlFor> on clipped
 * file inputs; a direct input.click() from the button handler is required.
 * Tip 215: call synchronously from the click handler (no await/setTimeout) or
 * WKWebView will not invoke the native open-panel delegate.
 */
export function triggerFileInput(input: HTMLInputElement | null | undefined): void {
  if (!input || input.disabled) return;
  try {
    input.click();
  } catch {
    /* WebKit may throw if not in a user gesture — caller must invoke from click */
  }
}
